export default __webpack_public_path__ + "static/media/Interior (10).eb968816.jpg";